import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container p-3 lg:py-8" }
const _hoisted_3 = { class: "sm:flex flex-col" }
const _hoisted_4 = { class: "sm:flex flex-col lg:flex-row justify-between items-start" }
const _hoisted_5 = { class: "visible lg:hidden w-full flex justify-end py-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_7 = { class: "card-main justify-between items-start w-full lg:w-3/12 h-full" }
const _hoisted_8 = { class: "flex flex-col w-full rounded-lg" }
const _hoisted_9 = { class: "flex justify-end w-full space-x-3" }
const _hoisted_10 = { class: "my-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, " Filter by locations ", -1)
const _hoisted_12 = { class: "relative mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 w-full h-px my-0 mx-0" })
], -1)
const _hoisted_14 = { class: "flex flex-col items-start justify-center w-full py-4 rounded-lg space-y-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, "Filter by job", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "space-y-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 w-full h-px my-0 mx-0" })
], -1)
const _hoisted_20 = { class: "flex flex-col items-start justify-center w-full py-4 rounded-lg space-y-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, "Filter by stage", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "space-y-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 w-full h-px my-0 mx-0" })
], -1)
const _hoisted_26 = { class: "flex flex-col items-start justify-center w-full py-4 rounded-lg space-y-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, "Filter by aplication date", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "space-y-3" }
const _hoisted_31 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 w-full h-px my-0 mx-0" })
], -1)
const _hoisted_33 = { class: "flex flex-col items-start justify-center w-full py-4 rounded-lg space-y-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, "Filter by salary", -1)
const _hoisted_35 = { class: "w-full" }
const _hoisted_36 = { class: "w-full my-3" }
const _hoisted_37 = { class: "flex justify-end" }
const _hoisted_38 = {
  key: 0,
  class: "mt-12"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 w-full h-px my-0 mx-0" })
], -1)
const _hoisted_40 = { class: "flex flex-col items-start justify-center w-full py-4 rounded-lg space-y-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 select-none font-medium" }, "Filter by Skills", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { class: "flex flex-col items-start justify-center w-full py-2 rounded-lg space-y-4" }
const _hoisted_45 = { class: "w-full" }
const _hoisted_46 = { class: "flex justify-end" }
const _hoisted_47 = {
  key: 0,
  class: "inline"
}
const _hoisted_48 = { class: "space-y-4 w-full lg:w-9/12 lg:pl-8 pb-8" }
const _hoisted_49 = { class: "flex flex-col lg:flex-row justify-between items-center lg:mt-0 mt-4" }
const _hoisted_50 = { class: "w-full flex flex-col" }
const _hoisted_51 = { class: "flex flex-row space-x-5 mt-3" }
const _hoisted_52 = { class: "hidden lg:block" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_54 = {
  key: 0,
  class: "p-10"
}
const _hoisted_55 = { key: 2 }
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<div class=\"flex w-full justify-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-60 w-60 text-gray-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><div class=\"text-primary justify-center flex w-full\"><span class=\"font-bold text-xl text-gray-400\">No candidates yet!</span></div>", 2)
const _hoisted_58 = [
  _hoisted_56
]
const _hoisted_59 = { class: "w-full py-3 flex flex-row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_SimpleDatePicker = _resolveComponent("SimpleDatePicker")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_RangeSlider = _resolveComponent("RangeSlider")!
  const _component_SkillCheckbox = _resolveComponent("SkillCheckbox")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_CardCandidateDetail = _resolveComponent("CardCandidateDetail")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_AddCandidatesForm = _resolveComponent("AddCandidatesForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-grow bg-background shadow-inner min-h-screen", 
        _ctx.candidates &&
        _ctx.candidates.candidates &&
        _ctx.candidates.candidates.length > 0 &&
        'h-full'
      ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  variant: "contained",
                  label: "Add candidate",
                  onOnClick: _ctx.createCandidate
                }, {
                  startIcon: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onOnClick"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-dark text-md font-bold",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                    }, " Clear all "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary text-md font-bold",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                    }, " Apply ")
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.locationSelected,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locationSelected) = $event)),
                        options: _ctx.locations,
                        label: "name",
                        placeholder: "All locations",
                        reduce: (name) => name
                      }, null, 8, ["modelValue", "options", "reduce"])
                    ])
                  ]),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand.jobs = !_ctx.expand.jobs)),
                      class: "flex flex-row justify-between w-full"
                    }, _hoisted_17)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item.id}-${index}`,
                        label: item.title,
                        value: item.id,
                        modelValue: _ctx.radioJob,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.radioJob) = $event))
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.jobs]
                  ])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expand.stage = !_ctx.expand.stage)),
                    class: "flex flex-row justify-between w-full"
                  }, _hoisted_23),
                  _withDirectives(_createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkStage, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item.value}-${index}`,
                        label: item.label,
                        value: item.value,
                        modelValue: _ctx.radioStage,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.radioStage) = $event))
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.stage]
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.expand.applicationDate = !_ctx.expand.applicationDate)),
                    class: "flex flex-row justify-between w-full"
                  }, _hoisted_29),
                  _withDirectives(_createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_SimpleDatePicker, {
                      placeholder: "Start date",
                      name: "start_date",
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.startDate) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_SimpleDatePicker, {
                      placeholder: "End date",
                      name: "end_date",
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endDate) = $event))
                    }, null, 8, ["modelValue"])
                  ], 512), [
                    [_vShow, _ctx.expand.applicationDate]
                  ]),
                  (_ctx.message !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.message), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.expand.range = !_ctx.expand.range)),
                    class: "flex flex-row justify-between w-full"
                  }, [
                    _hoisted_34,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.range && 'transform rotate-180 '])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_SwitchButton, {
                          label: "No salary",
                          labelClass: "text-base text-primary font-medium text-gray-400",
                          checked: _ctx.noSalary,
                          "onUpdate:checked": _cache[11] || (_cache[11] = (e) => _ctx.setNoSalary(e))
                        }, null, 8, ["checked"])
                      ])
                    ]),
                    (!_ctx.noSalary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createVNode(_component_RangeSlider, {
                            "onUpdate:modelValue": _ctx.updateRange,
                            rangeValuedata: _ctx.rangeValue
                          }, null, 8, ["onUpdate:modelValue", "rangeValuedata"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.expand.range]
                  ])
                ]),
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.expand.skills = !_ctx.expand.skills)),
                    class: "flex flex-row justify-between w-full"
                  }, _hoisted_43),
                  _withDirectives(_createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_SwitchButton, {
                          label: "No skills",
                          labelClass: "text-base text-primary font-medium text-gray-400",
                          checked: _ctx.noSkills,
                          "onUpdate:checked": _cache[13] || (_cache[13] = (e) => _ctx.setNoSkills(e))
                        }, null, 8, ["checked"])
                      ])
                    ]),
                    (!_ctx.noSkills)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillsList, (item) => {
                            return (_openBlock(), _createBlock(_component_SkillCheckbox, {
                              key: `item-checkbox-${item + 1}`,
                              names: _ctx.selectedSkills,
                              "onUpdate:names": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedSkills) = $event)),
                              label: item,
                              value: item,
                              fieldId: item
                            }, null, 8, ["names", "label", "value", "fieldId"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.expand.skills]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_SearchInput, {
                      placeholder: "Search for candidates...",
                      modelValue: _ctx.inputValue,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.inputValue) = $event)),
                      onOnSubmit: _ctx.applyFilters
                    }, null, 8, ["modelValue", "onOnSubmit"]),
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionSearch, (item, index) => {
                        return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                          key: `item-checkbox-${index + 1}`,
                          fieldId: item.id,
                          names: _ctx.restrict_attributes,
                          "onUpdate:names": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.restrict_attributes) = $event)),
                          label: `${item.name}`,
                          value: item.id
                        }, null, 8, ["fieldId", "names", "label", "value"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_Button, {
                      variant: "contained",
                      label: "Add candidate",
                      onOnClick: _ctx.createCandidate
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }, 8, ["onOnClick"])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass({
                  'sm:w-full sm:grid grid-cols-2':
                    _ctx.candidates &&
                    _ctx.candidates.candidates &&
                    _ctx.candidates?.candidates.length > 0,
                })
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createVNode(_component_Loading, {
                          active: _ctx.isLoading,
                          "onUpdate:active": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isLoading) = $event)),
                          "can-cancel": false,
                          loader: "spinner",
                          color: "#8908F9",
                          width: 128,
                          height: 128,
                          opacity: 0.8,
                          "is-full-page": true
                        }, null, 8, ["active", "opacity"])
                      ]))
                    : (_openBlock(), _createBlock(_component_CardCandidateDetail, {
                        key: 1,
                        candidates: 
                    _ctx.candidates &&
                    _ctx.candidates.candidates &&
                    _ctx.candidates?.candidates.length > 0
                      ? _ctx.candidates.candidates
                      : []
                  
                      }, null, 8, ["candidates"])),
                  (
                    !_ctx.isLoading &&
                    _ctx.candidates &&
                    _ctx.candidates.candidates &&
                    _ctx.candidates?.candidates.length <= 0
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
                    : _createCommentVNode("", true)
                ], 2),
                _withDirectives(_createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_Paginator, {
                    modelValue: _ctx.page,
                    page: _ctx.page,
                    pages: _ctx.candidates?.meta?.pagination?.total_pages,
                    "range-size": 1,
                    "onUpdate:modelValue": _ctx.updateHandler,
                    total: _ctx.candidates?.meta?.pagination?.total_count,
                    from: _ctx.candidates?.meta?.pagination?.from,
                    to: _ctx.candidates?.meta?.pagination?.to
                  }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
                ], 512), [
                  [_vShow, _ctx.candidates?.candidates?.length > 0 && !_ctx.isLoading]
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setShowModal(false))),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidatesForm, {
          onCloseModal: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setShowModal(false))),
          onGetCandidates: _ctx.getCandidates
        }, null, 8, ["onGetCandidates"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalUpgrade,
      onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showModalUpgrade = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showModalUpgrade = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}